import { render, staticRenderFns } from "./SaveIODConfirmationModal.vue?vue&type=template&id=73b5ac34&scoped=true"
import script from "./SaveIODConfirmationModal.vue?vue&type=script&lang=js"
export * from "./SaveIODConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./SaveIODConfirmationModal.vue?vue&type=style&index=0&id=73b5ac34&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b5ac34",
  null
  
)

export default component.exports